import React, { useState } from "react";
import styled from "styled-components";
import { TextArea } from "@sonder/ui/source/styled/fragments/TextArea";
import { borders, colors } from "@sonder/ui/source/styled/theme";

interface TextAreaProps {
  error?: boolean;
}
export const StyledChecklistItemTextArea = styled(TextArea)<TextAreaProps>`
  border: ${props => (props.error ? borders.error : borders.placeholder)};
  border-radius: 0.3rem;
  flex: 1;

  /* Much figma, revisit. */
  margin-left: -0.5rem;
  min-height: 2.3rem;
  padding: 0.4rem 0.5rem;

  &:hover,
  &:focus {
    background: ${colors.white};
    border: ${props => (props.error ? borders.error : borders.standard)};
  }
`;

interface ChecklistItemTextAreaProps {
  autoFocus?: boolean;
  children?: string;
  disabled?: boolean;
  error?: boolean;
  onBlur?(): void;
  onFocus?(): void;
  onChange?: (body: string) => void;
  placeholder?: string;
  required?: boolean;
}

export const ChecklistItemTextArea = ({
  autoFocus = false,
  children = "",
  disabled = false,
  error = false,
  onBlur = () => null,
  onFocus = () => null,
  onChange = () => null,
  placeholder = "Enter a name",
  required,
}: ChecklistItemTextAreaProps) => {
  const [value, setValue] = useState(children || "");
  return (
    <StyledChecklistItemTextArea
      autoFocus={autoFocus}
      disabled={disabled}
      error={error}
      placeholder={placeholder}
      required={required}
      value={value}
      onBlur={() => {
        onBlur();
        onChange(value);
      }}
      onChange={e => setValue(e.target.value)}
      onFocus={() => onFocus()}
    />
  );
};
